export function HeroImage({ src }) {
  return (
    <div className="aspect-[288/162] overflow-hidden rounded-[20px] md:aspect-[573/322] xl:aspect-[850/470]">
      <img src={src} className="block h-[100%] w-[100%]" alt="" />
    </div>
  )
}
